import {
    METHOD_DELETE,
    METHOD_GET,
    METHOD_POST,
    METHOD_PUT,
    SERVER_URL,
} from '../constants/api';
import { http } from './common';

import {
    headersAuth,
    headersAuthReceiveJson, headersAuthSendReceiveJson
} from '../headers';
import { apiHandleResponse } from '../../util/api';

const list = async (options, significance, showLowConfidenceClaims = false) => {
    return http.post(`/api/v2/cms/analysis/charges/${significance}`, { ...options, showLowConfidenceClaims });
};

const getStats = async (getStatspayload, significance=false, showLowConfidenceClaims = false) => {
    return http.post(`/api/v2/cms/analysis/charges/summary/${significance}`, { ...getStatspayload, showLowConfidenceClaims });
};

const downloadReport = async (payload, showSignificantVariance, showLowConfidenceClaims = false) => {
    return http.post(`/api/v2/cms/analysis/charges/report/${showSignificantVariance}`, { ...payload, showLowConfidenceClaims }, 'octet-stream' );
};

export {list, getStats, downloadReport}